var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantIndicatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7344 8.62533V5.66667C14.7344 4.42899 15.2612 3.242 16.1988 2.36683C17.1365 1.49166 18.4083 1 19.7344 1H21.6094C21.7751 1 21.9341 1.06146 22.0513 1.17085C22.1685 1.28025 22.2344 1.42862 22.2344 1.58333V3.33333C22.2344 4.57101 21.7076 5.758 20.7699 6.63316C19.8322 7.50833 18.5605 8 17.2344 8C15.9083 8 14.6365 8.49166 13.6988 9.36683C12.7612 10.242 12.2344 11.429 12.2344 12.6667C12.2344 15 13.4844 16.1667 13.4844 18.5C13.4844 19.7622 13.0458 20.9903 12.2344 22",
    stroke: "#282622",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00391 8.19191C2.95386 7.52037 4.08346 7.11144 5.26611 7.01093C6.44876 6.91041 7.63774 7.1223 8.69982 7.62283C9.76191 8.12336 10.6551 8.89277 11.2794 9.84484C11.9037 10.7969 12.2344 11.894 12.2344 13.0132C11.2844 13.6848 10.1548 14.0937 8.97216 14.1942C7.78951 14.2947 6.60053 14.0829 5.53844 13.5823C4.47635 13.0818 3.58313 12.3124 2.95885 11.3603C2.33457 10.4082 2.00391 9.31113 2.00391 8.19191Z",
    stroke: "#282622",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23438 23C2.23438 23 8.30965 22 12.2344 22C16.1591 22 22.2344 23 22.2344 23",
    stroke: "#282622",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIndicatorIcon);
export default __webpack_public_path__ + "static/media/PlantIndicatorIcon.5a90859729d57745da637b2ed84dd2d4.svg";
export { ForwardRef as ReactComponent };